module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lips-balms_c86146.jpg";